import { format, isValid } from 'date-fns';

export const toValidDate = (value: string | null | undefined): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  return isValid(date) ? date : null;
};

export const safeFormat = (
  value: string | null | undefined,
  pattern: string,
  fallback = '',
): string => {
  const date = toValidDate(value);
  return date ? format(date, pattern) : fallback;
};
